import React, { useEffect, useState } from 'react';
import { fetchUsers, createUser } from './api';
import UserForm from './components/UserForm';
import UserList from './components/UserList';

// Root app component - manages app state and wires form/list together
export default function App() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load users from backend
  const loadUsers = async () => {
    setLoading(true);
    const data = await fetchUsers();
    setUsers(data || []);
    setLoading(false);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  // Handler to add a user: call backend then refresh list
  const handleCreateUser = async (user) => {
    await createUser(user);
    await loadUsers();
  };

  return (
    <div style={{ padding: 20, fontFamily: 'Arial, sans-serif' }}>
      <h1>Sample Fullstack App</h1>
      <UserForm onCreate={handleCreateUser} />
      <hr />
      <h2>Saved Users</h2>
      {loading ? <div>Loading...</div> : <UserList users={users} />}
    </div>
  );
}
